import { createContext, useContext, useState } from 'react'

const ModalContext = createContext()

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    open: false,
    title: '',
  })

  const show = (title = 'Bilgi') => {
    setModal({ open: true, title })
  }

  const hide = () => {
    setModal({ ...modal, open: false })
  }

  return <ModalContext.Provider value={{ modal, show, hide }}>{children}</ModalContext.Provider>
}

export const useModal = () => useContext(ModalContext)
